import React from "react";
import "./LightsabarLoader.css";

// A minimal, backward-compatible spinner that accepts a few props so
// existing replacements that passed e.g. `size` or `message` don't get ignored.
const LightSpinner = ({ size, message, className }) => {
  // simple scale mapping for size prop (supports: 'sm', 'lg', numeric scale, default 1)
  let scale =  1;
  if (size === "sm") scale = 0.6;
  else if (size === "lg") scale = 1.4;
  else if (typeof size === "number") scale = size;

  const wrapperStyle = {
    transform: `scale(${scale})`,
  };

  return (
    <div
      className={className ? `light-spinner ${className}` : "light-spinner"}
      style={wrapperStyle}
    >
      <div className="flex flex-col items-center">
        <div id="loader">
          <div className="ls-particles ls-part-1"></div>
          <div className="ls-particles ls-part-2"></div>
          <div className="ls-particles ls-part-3"></div>
          <div className="ls-particles ls-part-4"></div>
          <div className="ls-particles ls-part-5"></div>

          <div className="lightsaber ls-left ls-gold"></div>
          <div className="lightsaber ls-right ls-blue"></div>
        </div>
        {message && (
          <div className="mt-2 text-sm text-gray-600 ls-message" aria-hidden>
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default LightSpinner;
